import { Navigate, Route, Routes } from 'react-router';

import { Layout } from 'components/molecules/Layout';
import { APP_ROUTES } from 'constants/appRoutes';
import { ApiKeyTemplatePage } from 'page/ApiKeyTemplatePage';
import { CrawlerPage } from 'page/CrawlerPage';
import { CustomerPage } from 'page/CustomerPage';
import { MenuCategoryPage } from 'page/MenuCategoryPage';
import { NotificationPage } from 'page/NotificationPage';
import { ReleaseComponentPage } from 'page/ReleasePage/ComponentPage';
import { ReleaseEmvironmentPage } from 'page/ReleasePage/EnvironmentPage';
import { ReleasePage } from 'page/ReleasePage/index';
import { ReleaseTaskPage } from 'page/ReleasePage/TaskPage';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Layout />}>
      <Route path="" element={<Navigate to={APP_ROUTES.CUSTOMER} replace />} />
      <Route path={APP_ROUTES.CUSTOMER} element={<CustomerPage />} />
      <Route path={APP_ROUTES.NOTIFICATION} element={<NotificationPage />} />
      <Route path={APP_ROUTES.CRAWLER} element={<CrawlerPage />} />
      <Route
        path={APP_ROUTES.APIKEYTEMPLATE}
        element={<ApiKeyTemplatePage />}
      />
      <Route path={APP_ROUTES.RELEASE} element={<ReleasePage />}>
        <Route
          index
          element={<Navigate to={APP_ROUTES.RELEASECOMPONENT} replace />}
        />
        <Route
          path={APP_ROUTES.RELEASECOMPONENT}
          element={<ReleaseComponentPage />}
        />
        <Route
          path={APP_ROUTES.RELEASEENVIRONMENT}
          element={<ReleaseEmvironmentPage />}
        />
        <Route path={APP_ROUTES.RELEASETASK} element={<ReleaseTaskPage />} />
      </Route>
      <Route path={APP_ROUTES.MENU_CATEGORY} element={<MenuCategoryPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export const AppRouter = () => <AppRoutes />;
